import { resolveOriginPolicy, type OriginPolicyContext } from "./server-origin-policy.js";

export function resolveBetterAuthTrustedOrigins(params: OriginPolicyContext = {}): string[] {
  return resolveOriginPolicy(params).authTrustedOrigins;
}
